import { DeleteForeverRounded, ThumbUpRounded } from '@mui/icons-material';
import { Button, CardContent, Grid, Stack, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import moment from 'moment';
import { useSnackbar } from 'notistack';
import React, { useState } from 'react';
import ShowMoreText from 'react-show-more-text';
import { useDeleteListDataMutation } from '../../api/apiSlice';
import fbThumbnail1 from '../../assets/fbThumbnail1.jpeg';
import fbThumbnail2 from '../../assets/fbThumbnail2.jpeg';
import fbThumbnail3 from '../../assets/fbThumbnail3.jpeg';
import useSettings from '../../hooks/useSettings';
import { FeedMedia } from '../../tabs/FeedTab';
import errorSnackbar from '../../utils/errorSnackbar';
import LightboxModal from '../export/LightboxModal';
import ConfirmSheet from './ConfirmSheet';

export const fbThumbnail = [fbThumbnail1, fbThumbnail2, fbThumbnail3][
    Math.floor(Math.random() * 3)
];

export default function ItemPastorPost({ post: postItem, onDelete }) {
    const [openLightbox, setOpenLightbox] = useState(false);
    const [selectedImage, setSelectedImage] = useState(0);
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);

    const { enqueueSnackbar } = useSnackbar();
    const { layout } = useSettings();
    const classes = useStyles();

    const spaced = layout === 'spaced';
    const [deleteItem, { isLoading }] = useDeleteListDataMutation();

    const {
        id: postId,
        title,
        name,
        date,
        description,
        dates,
        post,
        interaction,
        media,
    } = postItem;

    const imagesLightbox = media
        ?.filter(({ type }) => type === 'image')
        ?.map(({ link }) => link);

    return (
        <>
            <Grid item xs={12} className={classes.grid}>
                <div className={`${spaced && 'd-flex'} px-2 py-3`}>
                    <div style={{ flex: 1 }}>
                        <CardContent className="py-0">
                            <div className="d-flex align-items-center justify-content-between">
                                <Typography
                                    component="span"
                                    className="text-lowercase"
                                    variant="body2"
                                >
                                    {date
                                        ? moment(date).fromNow()
                                        : moment(dates?.updated).fromNow()}
                                </Typography>
                                <Button
                                    startIcon={<DeleteForeverRounded />}
                                    disabled={isLoading}
                                    color="secondary"
                                    onClick={() => setDeleteModalOpen(true)}
                                >
                                    Delete
                                </Button>
                                <ConfirmSheet
                                    open={deleteModalOpen}
                                    isLoading={isLoading}
                                    onCancel={() => setDeleteModalOpen(false)}
                                    onConfirm={async () => {
                                        const { data, error } =
                                            await deleteItem({
                                                list: `/op/posts/${postId}`,
                                            });

                                        errorSnackbar(error, enqueueSnackbar);

                                        if (data) {
                                            enqueueSnackbar('Post deleted');
                                            onDelete(true);
                                        }

                                        setDeleteModalOpen(false);
                                    }}
                                />
                            </div>
                            <Typography
                                style={{ textTransform: 'capitalize' }}
                                className="fw-bold mt-2 mb-1"
                            >
                                {(title || name)?.toLowerCase()}
                            </Typography>
                            <ShowMoreText lines={2} more="more" less="less">
                                {description || post || ' '}
                            </ShowMoreText>
                            <div onClick={() => setOpenLightbox(true)}>
                                <FeedMedia media={media} />
                            </div>
                            <Stack
                                sx={{ mt: 1 }}
                                direction="row"
                                className="align-items-center justify-content-between"
                            >
                                <div className="d-flex align-items-center">
                                    <ThumbUpRounded
                                        className="text-white"
                                        sx={{
                                            mr: 0.5,
                                            width: 16,
                                            height: 16,
                                            bgcolor: 'primary.main',
                                            padding: 0.2,
                                            borderRadius: 1,
                                        }}
                                    />
                                    <Typography variant="body2">
                                        {interaction?.likes || 0}
                                    </Typography>
                                </div>

                                <Typography variant="body2">
                                    0 Shares
                                </Typography>
                            </Stack>
                        </CardContent>
                    </div>
                </div>

                {media && (
                    <LightboxModal
                        images={imagesLightbox}
                        mainSrc={imagesLightbox[selectedImage]}
                        photoIndex={selectedImage}
                        setPhotoIndex={setSelectedImage}
                        isOpen={openLightbox}
                        onCloseRequest={() => setOpenLightbox(false)}
                    />
                )}
            </Grid>
        </>
    );
}

const useStyles = makeStyles((theme) => ({
    grid: {
        borderTopWidth: 2,
        borderTopColor: theme.palette.divider,
        borderTopStyle: 'solid',
    },
    memberAvatar: {
        width: 22,
        height: 22,
        position: 'relative',
        top: -20,
        border: `1px solid ${theme.palette.background.default}`,
    },
    stream: {
        width: '100%',
        borderRadius: theme.shape.borderRadius,
        display: 'flex',
        justifyContent: 'center',
        backgroundColor: 'rgba(0,0,0,.3)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundBlendMode: 'soft-light',
    },
    icon: {
        width: 62,
        height: 62,
    },
    modal: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '100%',
        bgcolor: 'background.paper',
    },
    iframe: {
        width: window.innerWidth,
        height: window.innerWidth * (9 / 16),
        backgroundColor: theme.palette.background.default,
    },
}));
